module.exports = __webpack_public_path__ + "img/proholdinghouse.9a0bf33e.png";